'use es6';

import { lowerUserAgent } from "./shared.js";

/** Running in jsdom or HappyDOM (used by unit tests). */
export const jsdom = /jsdom|happydom/.test(lowerUserAgent);